import React from 'react';

import { useAccommodationContext } from './AccommodationContext';
import AccommodationGroupCollapseHeader from './AccommodationGroupCollapseHeader';
import AccommodationGroupCollapseItem from './AccommodationGroupCollapseItem';
import AccommodationGroupStyledCollapse from './AccommodationGroupStyledCollapse';

const AccommodationGroupCollapse = () => {
  const { livingInfoData } = useAccommodationContext();

  const allKeys = livingInfoData.map((group: any) => group.group_id);
  const items = livingInfoData.map((group: any) => ({
    key: group.group_id,
    label: <AccommodationGroupCollapseHeader item={group} />,
    children: (
      <>
        {group.apartments.map((item: any) => (
          <AccommodationGroupCollapseItem key={item.id} item={item} />
        ))}
      </>
    ),
  }));

  return (
    <AccommodationGroupStyledCollapse
      key={allKeys?.length ? allKeys[0] : undefined}
      defaultActiveKey={allKeys}
      items={items}
    />
  );
};

export default AccommodationGroupCollapse;
